// extracted by mini-css-extract-plugin
export var dividerLine = "_9z-3";
export var itemImage = "_9z-9";
export var lightDivider = "_9z-4";
export var modalContent = "_9z-5";
export var modalContentCompact = "_9z-6";
export var productCard = "_9z-a";
export var productImage = "_9z-b";
export var productImageCompact = "_9z-7";
export var productImagePlaceholder = "_9z-c";
export var productImagePlaceholderCompact = "_9z-8";
export var progressBarBackground = "_9z-1";
export var progressBarContainer = "_9z-0";
export var progressBarFill = "_9z-2";